import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { action = 'create', id } = payload || {}

    if (action === 'cancel' || action === 'delete') {
      // Assuming delete uses the same path with ID but check docs if it has a specific endpoint
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_NOTIFICATIONS_SEND + `/${id}`)
    }

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_NOTIFICATIONS_SEND)
  },

  method(payload) {
    const { action = 'create' } = payload || {}
    if (action === 'cancel' || action === 'delete') return 'DELETE'
    return 'POST'
  },

  format(payload) {
    const {
      action = 'create',
      id,
      title,
      description,
      zone,
      target,
      targetRank,
      scheduledDateTime,
      priority,
    } = payload || {}

    // Pour la suppression, on n'envoie pas de body particulier ou juste l'id
    if (action === 'cancel' || action === 'delete') {
      return {}
    }

    const now = new Date().toISOString()
    let scheduledAt = null
    let status = 'sent'

    // Déterminer si c'est programmé
    if (scheduledDateTime) {
      const [datePart, timePart] = scheduledDateTime.split('T')
      scheduledAt = `${datePart}T${timePart}:00Z`
      const scheduledDate = new Date(scheduledAt)
      if (scheduledDate > new Date()) {
        status = 'scheduled'
      }
    }

    const type = 'system' // default type

    return {
      // Toujours générer un ID unique pour chaque notification envoyée
      id: id || crypto.randomUUID(),
      title: title || '',
      message: description || '',
      type: type,
      service: "rapidoo",
      audience: 'broadcast',
      target: target == 'broadcast' ? 'all' : target,
      data: {
        targetRank: targetRank || null,
        zone: zone || [],
        priority: priority || 'normal',
        status: status,
        scheduledAt: scheduledAt,
        createdBy: 'admin',
        ...(payload.data || {}),
      },
    }
  },

  async parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }

    // Appel de la fonction sans await comme demandé
    sendPushNotif(payload)

    return {
      statusCode: 200,
      message: 'ok',
      data: {
        saved: true,
      },
    }
  },
}

async function sendPushNotif(payload) {
  console.log("📢[saveNotification.js:98]: payload: ", payload);
  const { title, description, target } = payload || {}
  const url =
    'https://api.monrapidoo.com/notification/send/bulk?group=ultraxeno'

  // Déterminer le service selon la cible
  // Si target est un rider ou un restaurant, on choisit le service approprié
  let services = ['rapidoo']
  if (target === 'restaurant') {
    services = ['rapidoo-restaurant']
  } else if (target === 'rider') {
    services = ['rapidoo-rider']
  } else if (target === 'user') {
    services = ['rapidoo']
  } else if (target === 'broadcast' || target === 'all') {
    services = ['rapidoo', 'rapidoo-restaurant', 'rapidoo-rider']
  }

  // Effectuer une requête pour chaque service concerné
  services.forEach(service => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        title: title || '',
        content: description || '',
        service: service,
      }),
    }).catch(err => {
      console.error(`Erreur lors de l'envoi push pour ${service}:`, err)
    })
  })
}
